/**
 * A utility service containing helper functions for usage with dataservice resource requests
 */
export class ResourceHelperService {
  /**
   * Builds an object containing pagination and query params to be used when making GET requests against a backend resource.
   *
   * @param page The number of the page of data to be retrieved
   * @param perPageCount The number of items per page to be retrieved
   * @param queryString A query string used for matching records during data retrieval
   * @param sortBy A sorting expression to be used during data retrieval
   * @returns An object containing offset and limit properties for pagination purposes note that if no perPageCount param has
   *          been supplied the limit property will be defaulted to 1000 which is the maximum supported by the backend services.
   *          Additionally a q property can also be set to be used when querying the resource.
   */
  public buildRequestOptions(page: number, perPageCount: number, queryString?: string, sortBy?: string, groupBy?: string, additionalFields?: Boolean) {
    const options: any = {};

    if (angular.isNumber(page) && angular.isNumber(perPageCount)) {
      options.offset = (page - 1) * perPageCount;
      options.limit = perPageCount;
    } else {
      options.offset = 0;
      options.limit = 1000;
    }

    if(!angular.isNumber(page) && angular.isNumber(perPageCount)) {
      options.limit = perPageCount;
    }

    if (queryString) {
      options.q = queryString;
    }

    if (sortBy) {
      options.sortBy = sortBy;
    }

    if (groupBy) {
      options.grouping = groupBy;
    }

    if (additionalFields) {
      options.additionalFields = additionalFields;
    }

    return options;
  }

  /**
   * Builds an object containing grouping and query params to be used when making GETS on summary backend resources.
   *
   * @param grouping A grouping set of attributes on the GET endpoint
   * @param query A query to first pass over the result set
   * @returns An object containing q and grouping
   */
  public buildSummaryRequestOptions(grouping?: string, query?: string) {
    const options: any = {};
    if (grouping) {
      options.grouping = grouping;
    }

    if (query) {
      options.q = query;
    }

    return options;
  }
}